export default class Quantity {

    constructor(id, params, result, options) {
        this.id = id
        this.params = params
        this.result = result
        this.options = options
        this.$component = document.getElementById(this.id)

        this.init()
    }

    init() {
        this.addObservers()
    }

    reInit() {
    }

    addObservers() {
        this.$component.on('click', '.js-quantity-minus', function (e) {
            let $input = this.closest('.js-quantity').querySelector('.js-quantity-input'),
                ratio = Number.parseFloat($input.dataset.ratio),
                decimal = ratio.toString().split('.', 2)[1],
                length = 0,
                value = Number.parseFloat($input.value),
                newValue = null,
                availableQuantity = Number.parseFloat($input.dataset.availableQuantity)

            if (decimal) {
                length = decimal.length
            }

            if ((value - ratio) >= ratio) {
                newValue = (value - ratio).toFixed(length)
            }

            if (newValue > availableQuantity) {
                newValue = availableQuantity
            }

            $input.value = newValue

            $input.dispatchEvent(new Event('change'))
        })

        this.$component.on('click', '.js-quantity-plus', function (e) {
            let $input = this.closest('.js-quantity').querySelector('.js-quantity-input'),
                ratio = Number.parseFloat($input.dataset.ratio),
                decimal = ratio.toString().split('.', 2)[1],
                length = 0,
                value = Number.parseFloat($input.value),
                newValue = null,
                availableQuantity = Number.parseFloat($input.dataset.availableQuantity)

            if (decimal) {
                length = decimal.length
            }

            newValue = (value + ratio).toFixed(length)

            if (newValue > availableQuantity) {
                newValue = availableQuantity
            }

            $input.value = newValue

            $input.dispatchEvent(new Event('change'))
        })

        this.$component.on('keyup', '.js-quantity-input', function (e) {
            var $input = this,
                ratio = Number.parseFloat($input.dataset.ratio),
                decimal = ratio.toString().split('.', 2)[1],
                length = 0,
                value = Number.parseFloat($input.value),
                newValue = null,
                availableQuantity = Number.parseFloat($input.dataset.availableQuantity)

            if (decimal) {
                length = decimal.length
            }

            if (value > 0) {
                newValue = (ratio * (Math.floor(value / ratio))).toFixed(length)
            } else {
                newValue = ratio
            }

            if (newValue > availableQuantity) {
                newValue = availableQuantity
            }

            $input.value = newValue
        })

        this.$component.on('change', '.js-quantity-input', function (e) {
            let $input = this,
                timerId = $input.dataset.timerId,
                delay = $input.dataset.delay || 800

            if (timerId) {
                clearTimeout(timerId)
            }

            timerId = setTimeout(() => {
                BX.onCustomEvent($input, 'OnQuantityChange')
            }, delay)

            $input.dataset.timerId = timerId
        })
    }

}
